export default "__VITE_ASSET__d96c2fd6__"